import {connect} from 'react-redux';
import ParentComment, {ParentCommentProps} from './ParentComment';
import Action from '../../redux/Actions';
import CommentModel from '../../types/CommentModel';
import ReduxState from '../../types/ReduxState';
import {Dispatch} from 'redux';
import {QuizState} from '../../globals/Constants';

const mapStateToProps = (state: ReduxState, ownProps: ParentCommentContainerProps): Partial<ParentCommentProps> => {
   return {
      player: state.player || null,
      isSelected: state.selectedComment && (state.selectedComment.id === ownProps.comment.id || !!ownProps.replies.find(reply => reply.id === state.selectedComment.id)),
      isEditing: state.editingComment && state.editingComment.id === ownProps.comment.id,
      isAnyEditing: !!state.editingComment,
      annotationMode: state.annotationMode,
      hideAnnotation: state.hideAnnotation,
      comment: ownProps.comment,
      showCommentTime: ownProps.showCommentTime,
      replies: ownProps.replies,
      selectedComment: state.selectedComment,
      isOwner: state.isOwner,
      shouldShowUpdate: ownProps.shouldShowUpdate,
      currentUserId: state.currentUserId,
      isQuizzing: state.quizState !== QuizState.closed,
      themeName: state.themeName
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<ParentCommentProps> => {
   return {
      onSelect: selectedCommentId => {
         dispatch(Action.setSelectedComment(selectedCommentId));
      },
      onEditing: (editingCommentId = null) => {
         dispatch(Action.setEditingComment(editingCommentId));
      },
      setHideAnnotation: isHidden => {
         dispatch(Action.setHideAnnotation(isHidden));
      },
      setAnnotationMode: annotationMode => {
         dispatch(Action.setAnnotationMode(annotationMode));
      }
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(ParentComment);

interface ParentCommentContainerProps {
   comment: CommentModel;
   replies: CommentModel[];
   showCommentTime: boolean;
   shouldShowUpdate: boolean;
}
